module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_43.93b9339d.jpg";